<script>
import {Radar, mixins} from 'vue-chartjs'

export default {
  extends: Radar,
  mixins: [mixins.reactiveData],
  data() {
    return {
      dataCollection: {
        labels: [],
        datasets: [
          {
            label: '',
            backgroundColor: '#bceeeb',
            borderWidth: 0,
            data: []
          },
        ]
      },
      options: {
        animation: {
          duration: 0
        },
        title: {
          display: false,
        },
        scale: {
          ticks: {
            min: 0,
            max: 100,
          },
        },
        scales: {
          xAxes: [
          ],
          yAxes: [
          ],
        },
        legend: {
          display: false,
          position: 'top'
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  mounted() {
    this.chartData = this.dataCollection;
  },
  methods: {
    updateChart: function(){
      const newChartData = Object.assign({}, this.dataCollection);
      this.chartData = newChartData;
    },
  }
}
</script>